import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { Select } from "antd"
import { TIMEZONES } from "constants/timezones"

export const TimezoneSelect = ({ className, onChange, value, isAutoDetectEnabled = true }) => {
  const [userTimezone, setUserTimezone] = useState(null)

  useEffect(() => {
    if (!isAutoDetectEnabled) return

    // The browser's own IANA zone: what moment.tz.guess() returned, without bundling its 725 KB zone database
    const detectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const foundTimezone = TIMEZONES.find((tz) => tz.value === detectedTimezone)
    const defaultTimezone = foundTimezone ? foundTimezone.value : TIMEZONES[0].value

    setUserTimezone(defaultTimezone)
    if (onChange && !value) {
      onChange(defaultTimezone)
    }
  }, [onChange, value, isAutoDetectEnabled])

  // Never fall back to the detected timezone when auto-detect is off: showing a timezone that is not
  // the stored value makes re-picking it a no-op, since the Select only fires onChange on a real change.
  const isKnownValue = TIMEZONES.some((tz) => tz.value === value)
  const timezone = isKnownValue ? value : userTimezone

  return (
    <Select
      className={classNames(className)}
      style={{ maxWidth: "430px", width: "100%" }}
      placeholder="Select a timezone"
      value={timezone}
      onChange={onChange}
      options={TIMEZONES}
    />
  )
}

TimezoneSelect.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  isAutoDetectEnabled: PropTypes.bool
}
